module.exports = "<app-othertransaction-menu></app-othertransaction-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/othertransaction/othertransaction.component.html
// module id = ./src/app/othertransaction/othertransaction.component.html
// module chunks = main